var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8067 6.62386L18.1842 5.54377C17.6577 4.62985 16.4907 4.31456 15.5755 4.83896V4.83896C15.1399 5.09559 14.6201 5.1684 14.1307 5.04133C13.6413 4.91427 13.2226 4.59776 12.9668 4.16162C12.8023 3.88439 12.7139 3.56864 12.7105 3.24628V3.24628C12.7254 2.72947 12.5304 2.22865 12.17 1.85791C11.8096 1.48718 11.3145 1.27811 10.7975 1.27832H9.5435C9.03697 1.27831 8.55131 1.48016 8.194 1.83919C7.83669 2.19822 7.63717 2.68484 7.63961 3.19136V3.19136C7.6246 4.23717 6.77248 5.07706 5.72657 5.07695C5.40421 5.0736 5.08846 4.98519 4.81123 4.82066V4.82066C3.89606 4.29626 2.72911 4.61154 2.20254 5.52546L1.53435 6.62386C1.00841 7.53664 1.3194 8.70285 2.23 9.23255V9.23255C2.8219 9.57429 3.18653 10.2058 3.18653 10.8893C3.18653 11.5728 2.8219 12.2043 2.23 12.5461V12.5461C1.32056 13.0722 1.00923 14.2356 1.53435 15.1456V15.1456L2.16593 16.2348C2.41265 16.68 2.8266 17.0085 3.31619 17.1477C3.80578 17.2868 4.33064 17.2251 4.77462 16.9763V16.9763C5.21108 16.7216 5.73119 16.6518 6.21934 16.7824C6.70749 16.9131 7.12324 17.2333 7.37416 17.6719C7.5387 17.9491 7.62711 18.2649 7.63046 18.5872V18.5872C7.63046 19.6438 8.48696 20.5003 9.5435 20.5003H10.7975C11.8505 20.5003 12.7055 19.6494 12.7105 18.5964V18.5964C12.7081 18.0883 12.9089 17.6003 13.2682 17.241C13.6275 16.8817 14.1155 16.6809 14.6236 16.6834C14.9452 16.692 15.2596 16.78 15.5389 16.9396V16.9396C16.4517 17.4656 17.6179 17.1546 18.1476 16.244V16.244L18.8067 15.1456C19.0618 14.7077 19.1318 14.1863 19.0012 13.6966C18.8706 13.207 18.5502 12.7896 18.111 12.5369V12.5369C17.6718 12.2842 17.3514 11.8668 17.2208 11.3772C17.0902 10.8876 17.1603 10.3661 17.4154 9.92821C17.5812 9.63858 17.8214 9.39844 18.111 9.23255V9.23255C19.0161 8.70314 19.3264 7.54374 18.8067 6.63301V6.63301V6.62386Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.175,
    cy: 10.8891,
    rx: 2.63616,
    ry: 2.63616,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.9b7659afc81d0db206c04ee8d188f46c.svg";
export { ForwardRef as ReactComponent };